<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><span class="title1">Craft it with</span> <br/>PERLER <br/>BEADS</h1>
<h2 class="description">Easy and fun patterns for gifts and accessories from fuse beads</h2>
<h2 class="author">Prudence Rogers</h2>
<p class="logo"><img alt="" src="images/logo.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?0db05119